import { useEffect } from "react";
// 解决 ads 设置data-ad-status='unfilled' display:none; 搜索广告隐藏问题
// 定义广告状态类型
type AdStatus = "unfill-optimized" | "unfilled" | string;

// 广告元素接口
interface AdElement extends HTMLElement {
  getAttribute(name: "data-ad-status"): AdStatus | null;
  style: CSSStyleDeclaration;
  querySelector(selector: string): Element | null;
}

/**
 * 广告状态观察Hook
 * 用于监控Google广告的状态并根据状态调整显示
 */
export const useAdsObserver = () => {
  useEffect(() => {
    // 查询所有广告元素
    const ads = document.querySelectorAll<AdElement>("ins.adsbygoogle");
    // 为每个广告元素创建观察者
    const observers: MutationObserver[] = [];

    ads.forEach((ins: AdElement) => {
      const observer = new MutationObserver(() => {
        const status = ins.getAttribute("data-ad-status") as AdStatus;

        if (status === "unfill-optimized") {
          // 优化后未填充的广告显示为可见
          ins.style.display = "block";
          ins.style.visibility = "visible";
        } else if (status === "unfilled") {
          // 检查是否有内容填充
          const hasContent = ins.querySelector(".goog-rtopics") || ins.querySelector(".goog-rentries");

          if (!hasContent) {
            // 隐藏未填充的广告
            ins.style.display = "none";
          }
        }
      });

      // 开始观察data-ad-status属性变化
      observer.observe(ins, {
        attributes: true,
        attributeFilter: ["data-ad-status"],
      });

      observers.push(observer);
    });

    // 清理函数：断开所有观察者连接
    return () => {
      observers.forEach(observer => {
        observer.disconnect();
      });
    };
  }, []); // 空依赖数组，只在组件挂载时执行一次
};
